export const translationsSeparationTrafficModeMarking = {
  'atlas_bikelanes--buffer_left--key': 'Schutzraum (Links)',
  'atlas_bikelanes--buffer_right--key': 'Schutzraum (Rechts)',
  'atlas_bikelanes--marking_left--key': 'Markierung (Links)',
  'atlas_bikelanes--marking_left=barred_area': 'Schraffur',
  'atlas_bikelanes--marking_left=dashed_line': 'gestrichelte Linie',
  'atlas_bikelanes--marking_left=double_solid_line': 'doppelte durchgezogene Linie',
  'atlas_bikelanes--marking_left=pictogram': 'Piktogramm',
  'atlas_bikelanes--marking_left=solid_line': 'durchgezogene Linie',
  'atlas_bikelanes--marking_left=surface': 'Oberfläche',
  'atlas_bikelanes--marking_right--key': 'Markierung (Rechts)',
  'atlas_bikelanes--marking_right=barred_area': 'Schraffur',
  'atlas_bikelanes--marking_right=dashed_line': 'gestrichelte Linie',
  'atlas_bikelanes--marking_right=double_solid_line': 'doppelte durchgezogene Linie',
  'atlas_bikelanes--marking_right=pictogram': 'Piktogramm',
  'atlas_bikelanes--marking_right=solid_line': 'durchgezogene Linie',
  'atlas_bikelanes--marking_right=surface': 'Oberfläche',
  'atlas_bikelanes--separation_left--key': 'Abgrenzung (Links)',
  'atlas_bikelanes--separation_left=bollar': 'Poller',
  'atlas_bikelanes--separation_left=bump': 'Bodenschwelle',
  'atlas_bikelanes--separation_left=cone': 'Kegel',
  'atlas_bikelanes--separation_left=ditch': 'Graben',
  'atlas_bikelanes--separation_left=fence': 'Zaun',
  'atlas_bikelanes--separation_left=flex_post': 'Flexpfosten',
  'atlas_bikelanes--separation_left=greenery': 'Begrünung',
  'atlas_bikelanes--separation_left=guard_rail': 'Leitplanke',
  'atlas_bikelanes--separation_left=hedge': 'Hecke',
  'atlas_bikelanes--separation_left=jersey_barrier': 'Betonleitwand',
  'atlas_bikelanes--separation_left=kerb;bollard': 'Bordstein, dann Poller',
  'atlas_bikelanes--separation_left=kerb;parking_lane': 'Bordstein, dann Parkstreifen',
  'atlas_bikelanes--separation_left=kerb': 'Bordstein',
  'atlas_bikelanes--separation_left=no': 'keine physische Abgrenzung (explizit)',
  'atlas_bikelanes--separation_left=planter': 'Pflanzkübel',
  'atlas_bikelanes--separation_left=structure': 'Struktur',
  'atlas_bikelanes--separation_left=studs': 'Bodenmarkierungsnägel',
  'atlas_bikelanes--separation_left=tree_row': 'Baumreihe',
  'atlas_bikelanes--separation_left=vertical_panel': 'vertikales Panel',
  'atlas_bikelanes--separation_left=yes': 'unspezifische Abgrenzung',
  'atlas_bikelanes--separation_right--key': 'Abgrenzung (Rechts)',
  'atlas_bikelanes--separation_right=bollar': 'Poller',
  'atlas_bikelanes--separation_right=bump': 'Bodenschwelle',
  'atlas_bikelanes--separation_right=cone': 'Kegel',
  'atlas_bikelanes--separation_right=ditch': 'Graben',
  'atlas_bikelanes--separation_right=fence': 'Zaun',
  'atlas_bikelanes--separation_right=flex_post': 'Flexpfosten',
  'atlas_bikelanes--separation_right=greenery': 'Begrünung',
  'atlas_bikelanes--separation_right=guard_rail': 'Leitplanke',
  'atlas_bikelanes--separation_right=hedge': 'Hecke',
  'atlas_bikelanes--separation_right=jersey_barrier': 'Betonleitwand',
  'atlas_bikelanes--separation_right=kerb;bollard': 'Bordstein, dann Poller',
  'atlas_bikelanes--separation_right=kerb;parking_lane': 'Bordstein, dann Parkstreifen',
  'atlas_bikelanes--separation_right=kerb': 'Bordstein',
  'atlas_bikelanes--separation_right=no': 'keine physische Abgrenzung (explizit)',
  'atlas_bikelanes--separation_right=planter': 'Pflanzkübel',
  'atlas_bikelanes--separation_right=structure': 'Struktur',
  'atlas_bikelanes--separation_right=studs': 'Bodenmarkierungsnägel',
  'atlas_bikelanes--separation_right=tree_row': 'Baumreihe',
  'atlas_bikelanes--separation_right=vertical_panel': 'vertikales Panel',
  'atlas_bikelanes--separation_right=yes': 'unspezifische Abgrenzung',
  'atlas_bikelanes--traffic_mode_left--key': 'Verkehrsform (Links)',
  'atlas_bikelanes--traffic_mode_left=bicycle': 'Fahrrad',
  'atlas_bikelanes--traffic_mode_left=foot': 'Fußgänger',
  'atlas_bikelanes--traffic_mode_left=motor_vehicle': 'Kraftfahrzeuge',
  'atlas_bikelanes--traffic_mode_left=no': 'kein Verkehr (explizit)',
  'atlas_bikelanes--traffic_mode_left=parking': 'Parken',
  'atlas_bikelanes--traffic_mode_left=psv': 'ÖPNV (Bus/Tram)',
  'atlas_bikelanes--traffic_mode_right--key': 'Verkehrsform (Rechts)',
  'atlas_bikelanes--traffic_mode_right=bicycle': 'Fahrrad',
  'atlas_bikelanes--traffic_mode_right=foot': 'Fußgänger',
  'atlas_bikelanes--traffic_mode_right=motor_vehicle': 'Kraftfahrzeuge',
  'atlas_bikelanes--traffic_mode_right=no': 'kein Verkehr (explizit)',
  'atlas_bikelanes--traffic_mode_right=parking': 'Parken',
  'atlas_bikelanes--traffic_mode_right=psv': 'ÖPNV (Bus/Tram)',
}
